<template>
    <returnButton />
    <div class="main-container">
        <div class="title-header">
            <h1 class="title">Datos generales del paciente</h1>
        </div>
        <div class="content-container">
            <v-row justify="center" style="margin: 0 150px" no-gutters>
                <v-col
                    v-for="(item, index) in mostrarItemsPaciente"
                    :key="index"
                    cols="4"
                    class="text-center">
                    <span class="indicador">{{ item.indicador }}</span>
                    <span style="padding: 0 5px" class="indicador">:</span>
                    <span class="valor">
                        {{ item.valor }}
                        <span v-if="item.indicador === 'Peso' && item.valor"
                            >kg</span
                        >
                        <span v-if="item.indicador === 'Estatura' && item.valor"
                            >cm</span
                        >
                    </span>
                </v-col>
            </v-row>

            <!-- <patientInfo :selectedPatientId="patientId" :activeInput="false" /> -->
            <titleButtons
                titulo=""
                :botones="botones"
                :idParametro="$route.params.id" />
        </div>
    </div>
    <div class="main-container">
        <div class="title-header">
            <h1 class="title">Historial médico</h1>
        </div>
        <div class="content-container">
            <clinicTimeline
                :appointments="appointments"
                :practitionerId="practitionerId"
                @cancel-appointment="handleCancelAppointment"
                :patientId="patientId"
                @cancel-prescription="handleCancelPrescription" />
        </div>
    </div>
    <alertMessage ref="alertRef"></alertMessage>
</template>
<script>
import returnButton from '@/components/global/return-button.vue';
// import patientInfo from '@/components/global/patient-info.vue';
import titleButtons from '@/components/global/title-buttons.vue';
import clinicTimeline from '@/components/global/clinic-timeline.vue';
import alertMessage from '@/components/global/alert-message.vue';
// import patientAllergy from '@/components/global/patient-info.vue';

import { putNotes } from '@/api/notas';
import { cancelMedRequestById } from '@/api/expedientes';
import { getAppointment } from '@/api/notas';
import { getPatientById } from '@/api/pacientes';

import { memoizedGetPractitioner } from '@/api/practicante';

export default {
    components: {
        returnButton,
        // patientInfo,
        titleButtons,
        clinicTimeline,
        alertMessage,
        // patientAllergy,
    },
    props: ['patientId'],
    data() {
        return {
            appointments: [],
            practitionerId: '',
            dialogNote: false,
            selectedNoteId: '',
            botones: [
                {
                    name: 'CrearPaciente',
                    icon: 'mdi mdi-content-save',
                    label: 'Actualizar datos del paciente',
                },
                {
                    name: 'CrearDiagnostico',
                    icon: 'mdi-plus',
                    label: 'Iniciar consulta',
                },
            ],
            patientDisease: [],
            selectedRecipeId: null,
            dialogPrescription: false,
            prescriptionView: false,
            selectedPrescriptionId: '',
            mostrarItemsPaciente: [],
        };
    },
    created() {
        this.practitionerId = localStorage.getItem('id-user');
        this.fetchRecord();
    },
    methods: {
        fetchRecord() {
            getPatientById(this.patientId)
                .then((patient) => {
                    this.mostrarItemsPaciente = [
                        { indicador: 'Nombre', valor: patient.nombre },
                        {
                            indicador: 'Primer apellido',
                            valor: patient.primerApellido ?? null,
                        },
                        {
                            indicador: 'Segundo apellido',
                            valor: patient.segundoApellido ?? null,
                        },
                        {
                            indicador: 'Fecha de nacimiento',
                            valor: patient.birthdate,
                        },
                        { indicador: 'Edad', valor: patient.edad },
                        // { indicador: 'Sexo', valor: patient.sexo },
                        { indicador: 'Peso', valor: patient.peso },
                        { indicador: 'Estatura', valor: patient.estatura },
                    ];
                    const pesoItem = this.mostrarItemsPaciente.find(
                        (i) => i.indicador === 'Peso',
                    );
                    if (pesoItem) {
                        this.$emit('update-weight', { value: pesoItem.valor });
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
            getAppointment(this.patientId)
                .then(async (response) => {
                    await Promise.all(
                        response.map(async (appointment) => {
                            try {
                                const practitioner =
                                    await memoizedGetPractitioner(
                                        appointment.practitioner_id,
                                    );

                                appointment.practitioner = `${
                                    practitioner?.name?.[0] || ''
                                } ${practitioner?.lastname?.[0] || ''}${
                                    practitioner?.lastname?.[1]
                                        ? ' ' + practitioner.lastname[1]
                                        : ''
                                }`.trim();

                                await this.updatePractitioners(appointment);
                            } catch (error) {
                                console.error(error.message);
                            }
                        }),
                    );

                    this.appointments = response;
                })
                .catch((error) => {
                    console.log(error.message);
                });
        },
        async handleCancelAppointment(noteId) {
            let alertMessage = '';
            let alertStatus = '';

            try {
                await putNotes(noteId);

                alertMessage = 'Nota Cancelada';
                alertStatus = 'success';
            } catch (error) {
                alertMessage = `No se pudo cancelar la nota: ${error.message}`;
                alertStatus = 'error';
            } finally {
                this.fetchRecord();
            }
            this.messageAlertSnackBar(alertMessage, alertStatus);
            this.dialogNote = false;
        },
        messageAlertSnackBar(message, status) {
            const alertConfig = {
                message: message,
                type: status,
            };
            this.$refs.alertRef.show(alertConfig);
        },
        closeDialog() {
            this.dialogo = false;
        },
        closeDialogPrescription() {
            this.prescriptionView = false;
        },
        handleCancelPrescription(noteId) {
            cancelMedRequestById(noteId)
                .catch((error) => {
                    console.error(error);
                });
            this.fetchRecord();
            this.dialogPrescription = false;
        },
        async updatePractitioners(appointment) {
            if (!appointment?.requestedMedications) return;

            await Promise.all(
                Object.values(appointment.requestedMedications)
                    .flat()
                    .map(async (med) => {
                        if (!med?.practitioner) return;

                        try {
                            const p = await memoizedGetPractitioner(
                                med.practitioner,
                            );

                            med.practitioner = `${p?.name?.[0] || ''} ${
                                p?.lastname?.[0] || ''
                            }${
                                p?.lastname?.[1] ? ' ' + p.lastname[1] : ''
                            }`.trim();
                        } catch (err) {
                            console.error(
                                'Error obteniendo practitioner:',
                                err,
                            );
                        }
                    }),
            );
        },
    },
};
</script>
<style scoped>
.cont-botones {
    gap: 5px;
    display: flex;
    align-items: center;
}
.content-timeline {
    position: relative;
    width: 100%;
}

.timeline-card {
    background-color: #f7f7f7;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    width: 700px;
    position: relative;
    transition: all 0.3s ease;
}

.title-card {
    font-size: 18px;
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
    margin-bottom: 4px;
}

.card-content {
    margin-bottom: 10px;
    border-top: 1px solid #ddd;
}

.footer-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #ddd;
    padding-top: 10px;
    font-size: 0.8em;
    color: #666;
}

/* Estilos del botón de cancelación */
.cancel-button {
    background-color: #ffebee;
    color: #c62828;
    border: 1px solid #c62828;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 0.8em;
    cursor: pointer;
    transition: all 0.3s ease;
}

.cancel-button:hover:not(:disabled) {
    background-color: #ffcdd2;
    border-color: #ef9a9a;
}

.cancel-button:disabled {
    background-color: #f5f5f5;
    color: #9e9e9e;
    border: 1px solid #9e9e9e;
    cursor: not-allowed;
    opacity: 0.7;
}

.date {
    font-style: italic;
    letter-spacing: 0.5px;
    margin-right: 20px;
}

.medication-list {
    margin: 0;
    padding: 0;
    width: 100%; /* Asegura el ancho completo */
}

.medication-item {
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: normal;
    margin-bottom: 4px;
}

/* Estilo para notas canceladas */
.cancelled-note {
    background-color: #f0f0f0;
    opacity: 0.8;
}

.cancelled-note * {
    color: #666 !important;
    text-decoration: line-through;
}

.cancelled-note .info-status {
    background-color: #e0e0e0 !important;
    color: #616161 !important;
}

.operation-wrapper {
    display: flex;
    align-items: center;
}

.custom-button {
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-right: 6px;
}

.operation-icon {
    color: var(--color-principal);
    cursor: pointer;
}

.btn-active {
    border: 1px solid #ff0000;
    background-color: #fdecec;
    padding: 5px;
    color: #ff0000;
}
.btn-disabled {
    border: 1px solid #b0b0b0;
    background-color: #e0e0e0;
    color: #6c757d;
    padding: 5px;
    cursor: not-allowed;
}
.text-constrained {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.info-paciente {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 15px;
}
.indicador {
    color: var(--celeste-electrico);
    font-family: 'Trebuchet MS';
    font-weight: bold;
    font-size: 18px;
}
.valor {
    font-family: 'Trebuchet MS';
    font-size: 18px;
}

.peso-input :deep(.v-field__input) {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    min-height: 28px !important; /* más chico que el default */
}

</style>
